export const logoSettings = {
    tabs: {
        enterprise: '企业 Logo',
        watermark: '图片水印',
        drawing: '图纸 Logo',
    },
    message: {
        enterprise: {
            request: '要求 ：',
            // first: '1. 尺寸不超过400px*400px',
            first: '1. 大小不超过1MB',
            second: '2. 格式为 jpg、jpeg、png、bmp',
            content: '上传成功后，刷新浏览器查看效果',
        },
        watermark: {
            request: '要求 ：',
            // first: '1. 尺寸不超过400px*400px',
            first: '1. 大小不超过1MB',
            second: '2. 格式为 jpg、jpeg、png、bmp',
            third: '3. 建议上传白色透明背景的 png 格式',
        },
        drawing: {
            request: '要求 ：',
            // first: '1. 尺寸不超过400px*400px',
            first: '1. 大小不超过1MB',
            second: '2. 格式为 jpg、jpeg、png、bmp',
            note: '提示 ：',
            firstNote: '1. 图纸上 logo 会自动转为黑白色',
            secondNote: '2. 图纸 logo 只支持福昕家装智能设计端生成图纸',
        },
        prompt: {
            suffixError: '文件格式，仅支持 jpg、jpeg、png、bmp',
            overSize: '大小不超过1MB',
            overLimit: '长宽不超过400px * 400px',
            errorMessage: '上传失败',
            successMessage: '上传成功',
        },
    },
};
